export default "__VITE_ASSET__CRWX2Ewt__"